<template>
  <v-alert rounded outlined light color="deep-purple" class="pa-1 py-3">
    <v-card-title class="ma-0 py-2 pl-1 d-flex align-center justify-space-between">
      <h6 class="deep-purple--text lighten-2 font-weight-semibold">
        Historial de niveles
      </h6>
      <v-btn
        icon
        x-small
        :title="filterTitle"
        @click="onlyStageUpdates = !onlyStageUpdates"
      >
        <v-icon small :color="onlyStageUpdates ? 'deep-purple darken-1' : 'grey'">
          mdi-filter
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pb-0 px-1">
      <div v-if="loading" class="d-flex justify-center py-2">
        <v-progress-circular indeterminate color="deep-purple" size="24" />
      </div>

      <v-row v-else-if="errorMessage" align="center" justify="space-between" class="w-100 px-2">
        <span class="black--text font-weight-light caption">{{ errorMessage }}</span>
        <v-icon color="red lighten-1" size="20">mdi-alert-circle-outline</v-icon>
      </v-row>

      <v-row
        v-else-if="items.length === 0"
        align="center"
        justify="space-between"
        class="w-100 px-2"
      >
        <span class="black--text font-weight-light caption">Sin historial de niveles</span>
        <v-icon color="grey lighten-1" size="20">mdi-information-outline</v-icon>
      </v-row>

      <v-simple-table v-else dense class="level-history-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="caption deep-purple--text text--darken-1">Fecha</th>
              <th class="caption deep-purple--text text--darken-1">De</th>
              <th class="caption deep-purple--text text--darken-1">A</th>
              <th class="caption deep-purple--text text--darken-1">Origen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sortedItems" :key="item.id">
              <td class="caption">{{ formatDate(item.fechaEvento) }}</td>
              <td class="caption">
                <span v-if="item.oldLevel" class="level-chip level-chip--old">
                  {{ formatLevel(item.oldLevelValue || item.oldLevel) }}
                </span>
                <span v-else class="grey--text">—</span>
              </td>
              <td class="caption">
                <span v-if="item.nivelNuevo" class="level-chip level-chip--new">
                  {{ formatLevel(item.nivelNuevoValue || item.nivelNuevo) }}
                </span>
                <span v-else class="grey--text">—</span>
              </td>
              <td class="caption">
                <v-chip
                  x-small
                  class="font-weight-medium"
                  :color="item.source === 'CHALLENGE' ? 'indigo lighten-4' : 'teal lighten-4'"
                >
                  {{ item.source === 'CHALLENGE' ? 'Desafíos' : 'Diagnóstico' }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-alert>
</template>

<script>
import userAdvanceLevelService from '@/services/userAdvanceLevel.service';

export default {
  name: 'StudentLevelHistory',
  props: {
    studentId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    loading: false,
    items: [],
    errorMessage: '',
    onlyStageUpdates: true,
  }),
  computed: {
    filterTitle() {
      return this.onlyStageUpdates
        ? 'Mostrando solo cambios de stage'
        : 'Mostrando todos los eventos';
    },
    // El backend devuelve el historial en orden cronológico ascendente;
    // lo mostramos con el evento más reciente arriba (id como desempate).
    sortedItems() {
      return [...this.items].sort((a, b) => {
        const dateDiff = (b.fechaEvento || '').localeCompare(a.fechaEvento || '');
        return dateDiff !== 0 ? dateDiff : b.id - a.id;
      });
    },
  },
  watch: {
    onlyStageUpdates() {
      this.load();
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const { data } = await userAdvanceLevelService.getHistory(
          this.studentId,
          this.onlyStageUpdates,
        );
        this.items = Array.isArray(data) ? data : [];
      } catch (e) {
        const status = e?.response?.status;
        console.error(`[StudentLevelHistory] getHistory failed for studentId=${this.studentId}`, e);
        this.errorMessage = (status === 401 || status === 403)
          ? 'Sin acceso al historial de niveles.'
          : 'Error al obtener historial de niveles.';
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      return this.$moment(dateStr).format('DD/MM/YYYY');
    },
    formatLevel(level) {
      if (level == null) return '—';
      return `Nivel ${level}`;
    },
  },
};
</script>

<style scoped>
.level-history-table {
  background: transparent !important;
}
.level-history-table thead th {
  padding: 4px 8px !important;
}
.level-history-table tbody td {
  padding: 4px 8px !important;
}
.level-chip {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}
.level-chip--old {
  background-color: #ede7f6;
  color: #4527a0;
}
.level-chip--new {
  background-color: #e8f5e9;
  color: #2e7d32;
}
</style>
